import type { StaticImageData } from "next/image";
import IconMenuApps3d from "~/public/assets/services/apps/icon-menu-apps-3d.png";
import IconRefreshCheck3d from "~/public/assets/services/ia-first/icon-refresh-check-3d.png";
import IconCursorScreen3d from "~/public/assets/services/icon-cursor-screen-3d.png";
import IconDev3d from "~/public/assets/services/icon-dev-3d.png";
import IconMenuFlowFoundation from "~/public/assets/services/icon-menu-flow-foundation.png";
// import IconSearch3d from "~/public/assets/services/icon-search-3d.png"; // Product Discovery (oculto)
import IconStarIa3d from "~/public/assets/services/icon-star-ia-3d.png";

export type NavServiceLink = {
	icon: StaticImageData;
	label: string;
	description: string;
	href: string;
};

export type NavServiceGroup = {
	label: string;
	items: NavServiceLink[];
};

export type NavItem = {
	label: string;
	href: string;
	groups?: NavServiceGroup[];
};

/** Serviços do mega menu, agrupados por área. Fonte única para header e footer. */
export const servicesNavGroups: NavServiceGroup[] = [
	{
		label: "Design",
		items: [
			{
				icon: IconCursorScreen3d,
				label: "UX & UI Design",
				description: "Design orientado por negócio e usuários.",
				href: "/servicos/ux-ui",
			},
			{
				icon: IconMenuFlowFoundation,
				label: "FlowFoundation",
				description: "A base estratégica para produtos digitais.",
				href: "/servicos/flowfoundation",
			},
			// TODO: Product Discovery — oculto da navegação a pedido; a página
			// segue publicada em /servicos/product-discovery. Reativar removendo
			// o comentário abaixo.
			// {
			// 	icon: IconSearch3d,
			// 	label: "Product Discovery",
			// 	description: "Validamos problemas antes de construir.",
			// 	href: "/servicos/product-discovery",
			// },
		],
	},
	{
		label: "Desenvolvimento",
		items: [
			{
				icon: IconDev3d,
				label: "Desenvolvimento de sistemas",
				description: "Software sob medida para escalar operações.",
				href: "/servicos/desenvolvimento-de-software",
			},
			{
				icon: IconMenuApps3d,
				label: "Desenvolvimento de aplicativos",
				description: "Apps iOS e Android da ideia à loja.",
				href: "/servicos/desenvolvimento-de-aplicativos",
			},
			{
				icon: IconRefreshCheck3d,
				label: "Modernização de software legado",
				description: "Evolua sistemas sem parar a operação.",
				href: "/servicos/modernizacao-de-sistemas-legados",
			},
			// TODO: Outsourcing — reativar quando a página existir.
		],
	},
	{
		label: "Soluções IA",
		items: [
			{
				icon: IconStarIa3d,
				label: "IA transformation",
				description: "IA aplicada ao produto e operação.",
				href: "/servicos/ia-first",
			},
		],
	},
];

export const servicesNavItem: NavItem = {
	label: "Serviços",
	href: "/#servicos",
	groups: servicesNavGroups,
};

/** Lista plana dos serviços — usada no drawer mobile e na lista do footer. */
export const servicesNavLinks: NavServiceLink[] = servicesNavGroups.flatMap(
	(group) => group.items,
);
